package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class TreatmentRequest(
    val code: String,
    val name: String,
    val id: Int? = null
)